import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimTypes } from 'src/app/model/claim-type.model';

@Component({
    selector: 'app-personal-accident-claim',
    templateUrl: './personal-accident-claim.component.html',
    styleUrls: ['./personal-accident-claim.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalAccidentClaimComponent implements OnInit {

  constructor( private transactionInfoService: TransactionInfoService) {
      this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_HOME_PA]);
  }

  ngOnInit() {
  }

}


